module.exports = __webpack_public_path__ + "img/fblc-FE赛区.811b1ee4.jpg";